// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemrate{display:inline-block;background:#ffe0d9;border:1px solid #f6c9bf;border-radius:3px;padding:3px 3px 3px 3px;font-size:0;opacity:1}.itemrate-heart svg{fill:#ff7251}.itemrate-heart.mod-empty svg{opacity:.2}\n", ""]);
// Exports
module.exports = exports;
